<template>
  <div>
    <section class="content">
      <div
        class="pull-right btn-information col-xs-2"
        v-show="isAdmin"
      >
        <button
          class="btn btn-info btn-information-save"
          v-on:click="handleShow"
        >Show</button>
        <button
          class="btn btn-default btn-information-cancel"
          v-on:click="handleClear"
        >Clear</button>
        <button
          class="btn btn-default btn-information-cancel"
          v-on:click="handleDismiss"
        >Dismiss</button>
      </div>

      <section class="content">
        <div class="device-log-console-container">
          <iframe class="device-log-console" ref="console" frameborder="0" border="0" cellspacing="0"></iframe>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import utils from "../../utils";
import config from "../../config";
import api from '../../api';

// function arrayBufferToString(buf) {
//   return String.fromCharCode.apply(null, new Uint8Array(buf));
// }
function arrayBufferToString(buf) {
  let bytes = new Uint8Array(buf);
  let i = 0;
  let s = '';
  while (i < bytes.length) {
    let c = bytes[i++];
    if (c > 127) {
      if (c > 191 && c < 224) {
        if (i >= bytes.length) {
          throw new Error('UTF-8 decode: incomplete 2-byte sequence');
        }
        c = (c & 31) << 6 | bytes[i++] & 63;
      } else if (c > 223 && c < 240) {
        if (i + 1 >= bytes.length) {
          throw new Error('UTF-8 decode: incomplete 3-byte sequence');
        }
        c = (c & 15) << 12 | (bytes[i++] & 63) << 6 | bytes[i++] & 63;
      } else if (c > 239 && c < 248) {
        if (i + 2 >= bytes.length) {
          throw new Error('UTF-8 decode: incomplete 4-byte sequence');
        }
        c = (c & 7) << 18 | (bytes[i++] & 63) << 12 | (bytes[i++] & 63) << 6 | bytes[i++] & 63;
      } else {
        throw new Error('UTF-8 decode: unknown multibyte start 0x' + c.toString(16) + ' at index ' + (i - 1));
      }
    }
    if (c <= 0xffff) {
      s += String.fromCharCode(c);
    } else if (c <= 0x10ffff) {
      c -= 0x10000;
      s += String.fromCharCode(c >> 10 | 0xd800)
      s += String.fromCharCode(c & 0x3FF | 0xdc00)
    } else {
      throw new Error('UTF-8 decode: code point 0x' + c.toString(16) + ' exceeds UTF-16 reach');
    }
  }
  return s;
}

function getWsURL() {
  const url = new URL(config.serverURI);
  const protocol = url.protocol === "http:" ? "ws:" : "wss:";
  const room = Math.random().toString(36).slice(2);
  return `${protocol}//${url.host}/ws-log/${room}`;
}

function stdout(target, data) {
  const win = target.contentWindow;
  const { document } = win;
  const { body } = document;
  const isBottom = Math.abs(document.body.offsetHeight - win.innerHeight - win.scrollY) <= 30;
  const line = document.createElement("div");

  line.innerHTML = data;
  body.append(line);

  const lines = document.querySelectorAll("div");
  for (let n = lines.length; n >= 2000; n--) {
    body.firstElementChild.remove();
  }

  if (isBottom) {
    setTimeout(() => win.scrollTo(0, document.body.scrollHeight), 2);
  }
}

export default {
  name: "DeviceLog",
  data() {
    return {
      isAdmin: utils.checkIsAdmin(),
    };
  },
  beforeDestroy() {
    console.log("unmount");
    if (this.ws) {
      this.handleDismiss();
    }
  },
  mounted() {
    const { style } = this.$refs.console.contentWindow.document.body;
    style.fontFamily = "Consolas,'Courier New',Courier,FreeMono,monospace";
    style.fontWeight = "bold";
    style.fontSize = "14px";
    style.color = "rgb(0, 168, 0)";
    style.wordBreak = "break-all";
  },
  methods: {
    handleClear() {
      this.$refs.console.contentWindow.document.body.innerHTML = "";
    },
    async handleShow() {
      const { appid, deviceid } = this.$route.query;
      const url = getWsURL();
      console.log(url);
      const res = await api.post_blackhole({
        path: "/device/sendcmdadmin",
        cmd: "UPLOAD_LOG_WS",
        withLoading: true,
        appid,
        data: {
          deviceid,
          ws: url,
        },
      });
      console.log("handle show", res);
      this.runWs(url);
    },
    async handleDismiss() {
      if (!this.ws) return;

      console.log("dismiss ws");
      this.ws.removeEventListener("message", this.wsMessageListener);
      this.ws.close();

      const { appid, deviceid } = this.$route.query;
      const res = await api.post_blackhole({
        path: "/device/sendcmdadmin",
        cmd: "UPLOAD_LOG_WS",
        withLoading: true,
        appid,
        data: {
          deviceid,
          ws: ""
        },
      });
      console.log("handle dismiss", res);

      this.ws = null;
    },
    runWs(url) {
      const target = this.$refs.console;
      /* eslint-disable */
      const ansiUp = new AnsiUp();
      /* eslint-enable */
      const ws = new WebSocket(url);
      ws.binaryType = "arraybuffer";
      this.wsMessageListener = function (event) {
        try {
          const data = arrayBufferToString(event.data);
          console.log("ws <=", data);
          stdout(target, ansiUp.ansi_to_html(data));
        } catch (err) {
          console.error("ws <=r", err);
        }
      };
      ws.addEventListener("message", this.wsMessageListener);
      ws.addEventListener("error", (err) => {
        console.error("ws <=", err);
      });
      this.ws = ws;
    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// DeviceLog.vue?4a61aaf2